import React from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import Seo from "../../components/Seo/Seo"
import ArticleListing from "../../components/ArticleListing"
import "../index.sass"
import PageTransition from "../../components/PageTransition"
import PageHeader from "../../components/PageHeader"

const InterestingPage = (props) => {

	const { data } = props
	const posts = data.allMarkdownRemark.edges

	return (

		<PageTransition {...props}>

			<Seo title="Articles" keywords={[]} />
			<PageHeader title="Articles" description="Thoughts and ideas that might make you think about the world differently." />

			<div className="homepage">
				<ArticleListing posts={posts} />
			</div>

		</PageTransition>

	)

}

InterestingPage.propTypes = {

	data: PropTypes.object.isRequired,

}

export default InterestingPage

export const pageQuery = graphql`

	query {
		allMarkdownRemark(

			filter: {
				fields: {
					category: {in: ["Discourse", "Interesting", "Ideas", "Thoughts"]}
				}
				frontmatter: {
					draft: {ne: true}
				}
			}

			sort: {
				order: DESC, fields: [frontmatter___articlePublicationDate]
			}

		) {
		edges {
				...indexListing
			}
		}
	}

`